import React, { useEffect, useState, useCallback } from "react";
import { Box, Grid, CircularProgress, Typography } from "@mui/material";
import { Group } from "@mui/icons-material";
import apiService from "../../../../service/Api";
import { EnhancedMetricCard } from "../admin-widgets/AdminDashboard";
import StreamRecordKeeper from "./components/StreamRecordKeeper";
import StreamsLeaderboard, {
  CrewMember,
} from "./components/StreamsLeaderboard";
import DashboardCrewRatings from "./components/DashboardCrewRatings";

const TotalCrewCard: React.FC = () => {
  const [totalCrew, setTotalCrew] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTotalCrew = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get<{
        count: number;
        results: unknown[];
      }>("/api/crews/crew-members/");
      setTotalCrew(response.data.count);
    } catch (err: unknown) {
      console.error(err);
      setError("Failed to load total crew members.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTotalCrew();
  }, [fetchTotalCrew]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }
  const crewMembers: CrewMember[] = [
    { id: 1, name: "Cassandra Bunga", streamsAttended: 3 },
    { id: 2, name: "Tapiwa Chikwana", streamsAttended: 25 },
    { id: 3, name: "Ruvarashe Makaure", streamsAttended: 2 },
    { id: 4, name: "Nashel Mashumba", streamsAttended: 18 },
    { id: 5, name: "Leon Manhimanzi", streamsAttended: 32 },
    { id: 6, name: "Maxwell Manyanhaire", streamsAttended: 15 },
  ];
  return (
    <Box sx={{ flexGrow: 1, mt: 2 }}>
      <Grid container spacing={2} justifyContent="flex-start">
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <EnhancedMetricCard
            title="Total Crew"
            value={totalCrew}
            icon={Group}
            color="#4BA663"
            trend={7} // optional, you can remove or calculate dynamically
            subtitle="All Registered Crew"
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} justifyContent="flex-start">
        <Grid size={{ xs: 12, md: 4 }}>
          <StreamRecordKeeper />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <StreamsLeaderboard members={crewMembers} />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <DashboardCrewRatings />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TotalCrewCard;
